import { render } from "./Boxplot.vue?vue&type=template&id=3b0380de&scoped=true"
import script from "./Boxplot.vue?vue&type=script&lang=js"
export * from "./Boxplot.vue?vue&type=script&lang=js"

import "./Boxplot.vue?vue&type=style&index=0&id=3b0380de&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b0380de"]])

export default __exports__